<template>
	<core-layout-content medium>
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("participants") }}</template>
		</core-layout-headline-and-actions>

		<!-- Invite - display only if participant doesn't have login yet -->
		<j-card class="xs-12 bg5 r2 p4 mb4" v-if="!hasAssociatedLogin">
			<div class="fs5 lh125 fw7 mb1">{{ $t("invite_participant") }}</div>
			<div class="lh125 c6">{{ $t("invite_participant_description") }}</div>
			<j-button
				@click="$modal.show('inviteInternal')"
				class="mt4"
				type="bordered"
				>{{ $t("invite") }}</j-button
			>
		</j-card>

		<!-- Content -->
		<div class="flex wrap xs-12">
			<core-entity-card
				:entity="fetchedInternal"
				:pinnable="false"
				:hasActions="true"
				@added="fetchInternal"
				@updated="fetchInternal"
				@deleted="fetchInternal"
			/>
			<j-card class="xs-12 bg5 r2 p4 mt4" v-if="showReferralLink">
				<div class="fs5 lh125 fw7 mb2">{{ $t("referral_link") }}</div>
				<j-base-input-text
					ref="linkEl"
					:value="referralLink"
					size="small"
					isReadOnly
				></j-base-input-text>
				<!-- <div class="lh125 c6">{{ referralLink }}</div> -->
				<j-button
					@click="handleCopyReferralLink"
					class="mt2"
					type="bordered"
					size="small"
					>{{ isCopiedLink ? $t("copied") : $t("copy") }}</j-button
				>
			</j-card>
		</div>

		<!-- Footer menu -->
		<div class="flex wrap xs-12 xs-right bt1 bc7 pt2 mt8">
			<j-button
				type="error"
				@click="$modal.show('j-dialog')"
				v-can="'writeInternals'"
			>
				<crm-icon name="delete" size="normal" color="c5" class="mr1" />
				{{ $t("delete_participant") }}
			</j-button>
		</div>

		<!-- Delete Confirmation Modal -->
		<j-dialog
			:title="$t('delete_participant')"
			type="delete"
			@confirm="onDelete(id)"
			>{{ $t("errors.are_you_sure_you_want_to_delete_internal") }}</j-dialog
		>

		<!-- Modal to invite -->
		<core-modal name="inviteInternal" :headline="$t('invite_participant')">
			<invite-internal
				:internalId="id"
				@invite:finished="
					$modal.hide('inviteInternal')
					$router.push({ name: 'InternalsList' })
				"
			/>
		</core-modal>
	</core-layout-content>
</template>

<script>
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import CoreEntityCard from "@/modules/core/components/CoreEntityCard/"
import CoreModal from "@/modules/core/components/CoreModal/"
import InviteInternal from "../components/InviteInternal"
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import JDialog from "@/components/JDialog"
import CrmIcon from "@/components/CrmIcon"
import JBaseInputText from "@/components/JBaseInputText"
import api from "../api"
import get from "lodash.get"

export default {
	components: {
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		CoreEntityCard,
		JCard,
		JBaseInputText,
		JButton,
		CrmIcon,
		JDialog,
		CoreModal,
		InviteInternal
	},

	data() {
		return {
			id: this.$route.params.id,
			fetchedInternal: {},
			referralLink: "-",
			isCopiedLink: false
		}
	},

	created() {
		this.fetchInternal()
	},

	methods: {
		async fetchInternal() {
			this.isLoading = true
			const res = await api.internal({
				where: { id: this.id }
			})
			this.isLoading = false

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// If it doesn't exist, redirect
			if (res.data.internals.list.length === 0)
				this.$router.push({ name: "InternalsList" })

			// Assign
			this.fetchedInternal = res.data.internals.list[0]
			if (this.fetchedInternal.internalCode) {
				const salt = "ckb97i2w60c67010zejdhg3yc"
				const myCipher = this.cipher(salt)
				const hashedCode = this.fetchedInternal.internalCode.replace(" ", "")
				const baseUrl =
					this.$store.state.tenantId === "asia"
						? "https://imedical.asiainsurance.hk/"
						: "https://metlife-asia-uat2.quote.hk"
				this.referralLink = `${baseUrl}?agentCode=${myCipher(hashedCode)}`
			}
		},
		cipher(salt) {
			const textToChars = text => text.split("").map(c => c.charCodeAt(0))
			const byteHex = n => ("0" + Number(n).toString(16)).substr(-2)
			const applySaltToChar = code =>
				textToChars(salt).reduce((a, b) => a ^ b, code)

			return text =>
				text
					.split("")
					.map(textToChars)
					.map(applySaltToChar)
					.map(byteHex)
					.join("")
		},
		handleCopyReferralLink() {
			navigator.clipboard.writeText(this.referralLink)
			this.isCopiedLink = true
		},

		async onDelete(id) {
			this.isLoading = true
			const res = await api.deleteInternal({ id })
			this.isLoading = false

			// Error
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
			}

			// go back to previous page
			if (res) this.$router.push(`/${this.$store.state.tenantId}/internals/`)
			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text: this.$t("participant_deleted")
				}
			})
		}
	},

	computed: {
		hasAssociatedLogin() {
			return get(this, "fetchedInternal.associatedLogin.id") ? true : false
		},
		showReferralLink() {
			const isShow = ["asia_uat", "asia"].includes(this.$store.state.tenantId)
			return isShow
		}
	}
}
</script>

<style></style>
